import { memo } from 'react';
import { tolgee } from 'services/i18n/tolgee';

export interface CurrencyProps {
  value: General.Currency;
}

export const getCurrencySymbol = (value: General.Currency) => {
  return value === 'CNY' ? tolgee.t('market.元') : value;
};

const Currency = (props: CurrencyProps) => {
  const { value } = props;

  return <>{getCurrencySymbol(value)}</>;
};

export default memo(Currency);
